import React from "react";
import { LocaleLabels, SUPPORTED_LOCALES } from "@packages/global";
import { LanguageSwitcher as SharedLanguageSwitcher } from "@packages/ui";
import { useLanguageStore } from "../stores/languageStore";

interface LanguageSwitcherProps {
  compact?: boolean;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  compact = false,
}) => {
  const { locale, setLocale } = useLanguageStore();
  const locales = SUPPORTED_LOCALES.map((loc) => ({
    value: loc,
    shortLabel: LocaleLabels[loc].short,
    fullLabel: LocaleLabels[loc].full,
  }));
  return (
    <SharedLanguageSwitcher
      compact={compact}
      locale={locale}
      setLocale={(nextLocale) => setLocale(nextLocale as (typeof locale))}
      locales={locales}
    />
  );
};

export default LanguageSwitcher;
